import React, {useEffect, useReducer, useState} from 'react';
import Login from './Pages/Login'
import {
  BrowserRouter as Router,
  Switch,
  useHistory,
  Route,
  Redirect
} from "react-router-dom";
import DataConnectorVerification from "./Pages/DataConnectorVerification/DataConnectorVerification";
import Header from "./Pages/Dashboard/Header/Header";
import SideBar from "./Pages/Dashboard/SideBar";
import DataPool from "./Pages/Dashboard/Pages/DataPool/DataPool";
import DataConnectorTest from "./Pages/DataConnector/DataConnectorTest";
import UserManagement from "./Pages/Dashboard/Pages/UserManagement";
import Index from "./Pages/Dashboard/index";
import ProcessMap from "./Pages/Dashboard/index/ProcessMap";
import ConformanceChecking from "./Pages/Dashboard/index/ConformanceChecking";
import DataAnalysis from "./Pages/Dashboard/index/dataAnalysis";
import BpmnModelsList from "./Pages/Dashboard/index/BpmnModelsList";
import ProcessCompare from "./Pages/Dashboard/index/ProcessCompare";
import ShowBpmn from "./Pages/Dashboard/index/ShowBpmn";
import AutomaticBpmnGenerate from "./Pages/Dashboard/index/AutomaticBpmnGenerate";
import AppContext from "./context/appContext";
import WorkSpace from "./Pages/ControlPanel/WorkSpace";
import GraphReducer from "./context/GraphReducer";
import SvgMap from "./Pages/Dashboard/index/processMap/SvgMap";
import OfflineErrorBox from "./Pages/Componnets/EsmManagement/offlineErrorBox/OfflineErrorBox";
import GenerateBpmnModel from "./Pages/Dashboard/index/GenerateBpmnModel";
import ProcessExplorer from "./Pages/Dashboard/index/ProcessExplorer";
import ConfirmUserVerification from "./Pages/login/ConfirmUserVerification";
import {initialState} from "./context/IntialState";
import {QueryClientProvider, QueryClient} from "@tanstack/react-query";
import OverviewDashboard from "./Pages/Dashboard/OverviewDashboard/OverviewDashboard";
import SsoCallbackPage from "./Pages/SsoCallbackPage";

const Empty = () => {
  return <div></div>
}
const ProcessMiningPanel = ({component: Component, ...rest}) => (
  <Route {...rest} render={(props) => {
    if (!localStorage.getItem('token')) {
      const {pathname, search, hash} = props.location;
      sessionStorage.setItem('authCallbackUrl', `${pathname}${search}${hash}`);
      return <Redirect to="/"/>;
    }

    return (
      <Index>
        <Component {...props} {...rest} />
      </Index>
    );
  }}/>
);

const client = new QueryClient();

function App() {

  const [onlineStatus, setOnlineStatus] = useState(true);

  useEffect(() => {
    function changeStatus() {
      setOnlineStatus(navigator.onLine);
    }

    window.addEventListener("online", changeStatus);
    window.addEventListener("offline", changeStatus);
    return () => {
      window.removeEventListener("online", changeStatus);
      window.removeEventListener("offline", changeStatus);
    };
  }, []);


  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    if(window.location.origin.toLowerCase().includes('rahkav')){
      link.href = window.location.origin+'/rahkav/favicon.ico';
    }else{
      link.href = window.location.origin+'/favicon.ico';
    }
  }, []);

  const [state, dispatch] = useReducer(GraphReducer, initialState);
  const history = useHistory();
  const [openTabs, setOpenTabs] = useState([]);
  const [allowGetTab, setAllowGetTab] = useState('allow');
  const [uid, setUid] = useState({});
  const [view, setView] = useState('caseCount');
  const [processCompareView, setProcessCompareView] = useState('caseCount');
  const [filter, setFilter] = useState({});
  const [events_cases, setEvents_cases] = useState({});
  const [filterDone, setFilterDone] = useState(false);
  const [conformanceCheckingData, setConformanceCheckingData] = useState({});
  const [workspace, setWorkspace] = useState([]);
  const [workspacesInfo, setWorkspacesInfo] = useState([]);
  const [analysis, setAnalysis] = useState([]);
  const [analysisId, setAnalysisId] = useState("");
  const [selectedWorkspaceInfo, setSelectedWorkspaceInfo] = useState({id: null, name: null});
  const [caseCoverageData, setCaseCoverageData] = useState({})
  const [disabledCostProperty, setDisabledCostProperty] = useState(false)
  const [autoSaveData, setAutoSaveData] = useState({
    processMapFilters: [],
    processMapVariants: [1],
    processCompareVariants: false,
    processCompareFilters: []
  });
  const [listOfVariants, setListOfVariants] = useState([]);
  const [network, setNetwork] = useState(null)
  const [compareId, setCompareId] = useState(null)
  const [compareColor, setCompareColor] = useState('#8A0FFF')
  // const [compareColor , setCompareColor] = useState('#FFFFFF')
  const [changeVariantsFilter, setChangeVariantsFilter] = useState(false);
  const [dataChartCompare, setDataChartCompare] = useState(null);
  const [layerList, setLayerList] = useState([])
  const [lostWorkspaceDataConnector, setLostWorkspaceDataConnector] = useState(false);
  const [saveAnalysisStatus, setSaveAnalysisStatus] = useState(null);
  const [saveWorkspaceStatus, setSaveWorkspaceStatus] = useState({});
  const [saveGenerateBpmnFilters, setSaveGenerateBpmnFilters] = useState({});
  const [explorerActiveTab, setExplorerActiveTab] = useState('variantExplorer');
  const [filtersSubmitClicked, setFiltersSubmitClicked] = useState(false);
  const [hasSavedFilters, setHasSavedFilters] = useState(false);
  const [dataAnalysisFilters, setDataAnalysisFilters] = useState(null);
  const [processCompareSecondLayerInfos, setProcessCompareSecondLayerInfos] = useState({sliderColor: ""})
  const [isFiltersModalOpen, setIsFiltersModalOpen] = useState(false)
  const [isClickedOnLayerSelection, setIsClickedOnLayerSelection] = useState(false)
  const [isVariantExplorerLinked, setIsVariantExplorerLinked] = useState(false)
  const [activeLayerInfo, setActiveLayerInfo] = useState(null)
  const [layersFilters, setLayersFilters] = useState(null)
  const [apiStatusProcessExplorer, setApiStatusProcessExplorer] = useState(null)
  const [callbackUrl, setCallbackUrl] = useState()



  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    if(window.location.origin.toLowerCase().includes('rahkav')){
      link.href = window.location.origin+'/rahkav/favicon.ico';
    }else{
      link.href = window.location.origin+'/favicon.ico';
    }
  }, []);

  const handleSaveGenerateBpmnFilters = (data) => {
    if (data) {
      setSaveGenerateBpmnFilters(data);
    } else {
      return saveGenerateBpmnFilters;
    }
  }

  const handleSaveWorkspaceStatus = (status) => {
    if (status) {
      setSaveWorkspaceStatus(status);
    } else {
      return saveWorkspaceStatus;
    }
  }

  const handleSaveAnalysisStatus = (status) => {
    if (status) {
      setSaveAnalysisStatus(status);
    } else {
      return saveAnalysisStatus;
    }
  }

  const handleLostWorkspaceDataConnector = (state) => {
    if (state) {
      setLostWorkspaceDataConnector(state);
    } else {
      return lostWorkspaceDataConnector;
    }
  }

  const handleAddTab = (id, title, link) => {
    if (id === 'all') {
      setOpenTabs(title)
      return
    }
    const isFindTab = openTabs.find(item => item.id === id);
    if (!isFindTab) {
      setOpenTabs([...openTabs, {id, title, link}]);
    }
  }
  const handleAllowGetTab = type => {
    if (type) setAllowGetTab(type)
    else return allowGetTab
  }
  const handleRemoveTab = (id) => {
    if (id === 'all') {
      setOpenTabs([])
      return;
    }
    const remainingTabs = openTabs.filter(item => item.id !== id);
    setOpenTabs(remainingTabs);
  }
  const handleDisableCostProperty = (prop) => {
    if (prop !== undefined) setDisabledCostProperty(prop)
    else return disabledCostProperty
  }
  const handleConformanceCheckingData = data => {
    if (data) setConformanceCheckingData(data)
    else return conformanceCheckingData
  }
  const handleLayerList = data => {
    if (data) setLayerList(data)
    else return layerList
  }
  const handleDataChartCompare = state => {
    if (state) setDataChartCompare(state)
    else return dataChartCompare
  }
  const handleAutoSave = (state, type) => {
    if (state) {
      setAutoSaveData(state)
    } else return autoSaveData
  }
  const handleListOfVariants = (state) => {
    if (state) setListOfVariants(state)
    else return listOfVariants
  }
  const handleUid = id => {
    if (id) {
      setUid(id)
    } else return uid
  }
  const handleEvents_cases = data => {
    if (data) setEvents_cases(data)
    else return events_cases
  }
  const handleCompareId = data => {
    if (data === null) setCompareId(null)
    if (data) {
      setCompareId(data)
    } else return compareId
  }
  const handleCompareColor = hex => {
    if (hex) setCompareColor(hex)
    else return compareColor
  }
  // const handleCompareChangeColor = hex => {
  //   if(hex) setCompareColor(hex)
  //   else return compareChangeColor;
  // }
  const selectView = (type, data) => {
    if (type === '/variant-explorer') setView(data)
    else setProcessCompareView(data)
  }
  const selectFilter = f => {
    if (f) {
      setFilter(f)
    } else return filter
  }
  const actionFilter = f => {
    if (f) setFilterDone(f)
    else return filterDone
  }

  const handleWorkspace = w => {
    if (w) setWorkspace(w)
    else return workspace
  }
  const handleWorkspacesInfo = info => {
    if (info) setWorkspacesInfo(info)
    else return workspacesInfo
  }
  const handleAnalysis = a => {
    if (a) setAnalysis(a)
    else return analysis
  }
  const handleSelectedWorkspaceInfo = info => {
    if (info) setSelectedWorkspaceInfo(info)
    else return selectedWorkspaceInfo
  }
  const handleChangeVariantsFilter = (ids) => {
    if (ids) setChangeVariantsFilter(ids)
    else return changeVariantsFilter
  }
  const handleExplorerActiveTab = (tabName) => {
    if (tabName) setExplorerActiveTab(tabName);
    else return explorerActiveTab;
  }
  const handleFiltersSubmitClicked = (param) => {
    if (param !== null && param !== undefined) setFiltersSubmitClicked(param);
    else return filtersSubmitClicked;
  }
  const handleHasSavedFilters = (param) => {
    if (param !== null && param !== undefined) {
      setHasSavedFilters(param)
    } else {
      return hasSavedFilters;
    }
  }
  const handleLayersFilters = data => {
    if (data) {
      setLayersFilters(data)
    } else {
      return setLayersFilters
    }
  }
  const handleCaseCoverageData = data => {
    if (data) {
      setCaseCoverageData(data)
    } else {
      return caseCoverageData
    }
  }

  const handleOverrideDataAnalysisFilters = (data) => {
    if (data) {
      setDataAnalysisFilters(data)
    } else {
      return dataAnalysisFilters;
    }
  }

  const handleProcessCompareSecondLayerInfos = (infos) => {
    if (infos) {
      setProcessCompareSecondLayerInfos(infos)
    } else {
      return processCompareSecondLayerInfos
    }
  }

  const handleIsFiltersModalOpen = (boolean) => {
    if (boolean !== undefined && boolean !== null) {
      setIsFiltersModalOpen(boolean)
    } else {
      return isFiltersModalOpen
    }
  }

  const handleIsClickedOnLayerSelection = (boolean) => {
    if (boolean !== undefined && boolean !== null) {
      setIsClickedOnLayerSelection(boolean)
    } else {
      return isClickedOnLayerSelection
    }
  }

  const handleIsVariantExplorerLinked = (boolean) => {
    if (boolean !== undefined && boolean !== null) {
      setIsVariantExplorerLinked(boolean)
    } else {
      return isVariantExplorerLinked
    }
  }

  const handleApiStatusProcessExplorer = (status) => {
    if (status !== undefined && status !== null) {
      setApiStatusProcessExplorer(status)
    } else {
      return apiStatusProcessExplorer
    }
  }

  const handleCallbackUrl = (url) => {
    if (url) {
      setCallbackUrl(url)
    } else {
      return callbackUrl
    }
  }

  // const [state, dispatch] = useReducer((state, action) => {
  //   const { type } = action;
  //   switch(action) {
  //     case 'action description':
  //       const newState = // do something with the action
  //       return newState;
  //     default:
  //       throw new Error()
  //   }
  // }, []);

  // const [state, dispatch] = useReducer(reducer, initialArg, init);
  // const initialState = {count: 0};
  //
  // function reducer(state, action) {
  //   switch (action.type) {
  //     case 'increment':
  //       return {count: state.count + 1};
  //     case 'decrement':
  //       return {count: state.count - 1};
  //     default:
  //       throw new Error();
  //   }
  // }

  // function Counter({initialCount}) {
  //   const [state, dispatch] = useReducer(reducer, initialCount, init);
  //   return (
  //       <>
  //         Count: {state.count}
  //         <button
  //             onClick={() => dispatch({type: 'reset', payload: initialCount})}>
  //           Reset
  //         </button>
  //         <button onClick={() => dispatch({type: 'decrement'})}>-</button>
  //         <button onClick={() => dispatch({type: 'increment'})}>+</button>
  //       </>
  //   );
  // }


  // function Counter() {
  //   const [state, dispatch] = useReducer(reducer, initialState);
  //   return (
  //       <>
  //         Count: {state.count}
  //         <button onClick={() => dispatch({type: 'decrement'})}>-</button>
  //         <button onClick={() => dispatch({type: 'increment'})}>+</button>
  //       </>
  //   );
  // }

try {
  return (
      <AppContext.Provider value={{
        handleLayerList,
        openTabs,
        handleAllowGetTab,
        handleAddTab,
        handleRemoveTab,
        handleUid,
        handleEvents_cases,
        selectView,
        selectFilter,
        actionFilter,
        handleConformanceCheckingData,
        handleWorkspace,
        handleWorkspacesInfo,
        handleSelectedWorkspaceInfo,
        handleAnalysis,
        handleAutoSave,
        handleListOfVariants,
        handleCompareId,
        handleCompareColor,
        handleChangeVariantsFilter,
        handleDataChartCompare,
        handleLostWorkspaceDataConnector,
        handleSaveAnalysisStatus,
        handleSaveWorkspaceStatus,
        handleSaveGenerateBpmnFilters,
        handleExplorerActiveTab,
        handleFiltersSubmitClicked,
        handleHasSavedFilters,
        handleOverrideDataAnalysisFilters,
        handleCaseCoverageData,
        handleProcessCompareSecondLayerInfos,
        handleLayersFilters,
        handleIsFiltersModalOpen,
        handleIsClickedOnLayerSelection,
        handleIsVariantExplorerLinked,
        handleApiStatusProcessExplorer,
        handleDisableCostProperty,
        handleCallbackUrl,
        onlineStatus,
        view,
        processCompareView,
        network,
        dispatch,
        state,
        analysisId,
        setAnalysisId,
      }}>
        <QueryClientProvider client={client}>
          <Router history={history}>
            <Switch>
              <Route path="/sso/callback" exact component={SsoCallbackPage}/>
              <Route path="/" exact={true} component={Login}/>
              <Route path={"/confirm/:code"} component={ConfirmUserVerification}/>
              <Route path="/reset-password/:token" component={Login}/>
              <Route path="/graph" component={SvgMap}/>
              <Route path="/data-connector" component={DataConnectorTest}/>
              {/*<Route path="/confirm/:code" component={Confirm}/>*/}
              <Route path="/data-connector-verification/:page" component={DataConnectorVerification}/>
              <ProcessMiningPanel
                  path="/show-generated-bpmn"
                  exact
                  pageTitle={{title: "BPMN models", sidebar: false}}
                  component={AutomaticBpmnGenerate}
              />
              <ProcessMiningPanel
                  path="/bpmn-models"
                  exact pageTitle={{title: "BPMN models", sidebar: false}}
                  component={BpmnModelsList}
                  showContent={"bpmn"
                  }/>
              <ProcessMiningPanel
                  path="/show-bpmn"
                  pageTitle={{title: "BPMN models", sidebar: false}}
                  component={ShowBpmn}
              />

              <ProcessMiningPanel
                  path="/map"
                  pageTitle={{title: "process Explorer", sidebar: true}}
                  sidebarItems={['filters', 'views']}
                  component={Empty}
              />
              <ProcessMiningPanel
                  path="/process-explorer"
                  pageTitle={{title: "process Explorer", sidebar: true}}
                  sidebarItems={['filters', 'views']}
                  component={ProcessExplorer}
              />
              <ProcessMiningPanel
                  path="/variant-explorer"
                  pageTitle={{title: "Variant Explorer", sidebar: true}}
                  sidebarItems={['filters', 'views']}
                  component={ProcessMap}
              />
              <ProcessMiningPanel
                  path="/conformance-checking"
                  pageTitle={{title: "Conformance Checking", sidebar: true}}
                  // sidebarItems={['filters', 'views', 'bpmnModel']}
                  sidebarItems={['filters']}
                  component={ConformanceChecking}
              />
              <ProcessMiningPanel
                  path="/generate-bpmn-model"
                  pageTitle={{title: "Generate BPMN Model", sidebar: true}}
                  sidebarItems={['filters']}
                  component={GenerateBpmnModel}
              />
              <ProcessMiningPanel
                  path="/process-compare"
                  pageTitle={{title: "Process Compare", sidebar: true}}
                  sidebarItems={['filters', 'views']}
                  component={ProcessCompare}
              />
              <ProcessMiningPanel
                  path="/conformance-checking-list"
                  pageTitle={{title: "Conformance Checking", sidebar: false}}
                  sidebarItems={['filters']}
                  component={BpmnModelsList}
                  showContent={"conformanceChecking"}
              />
              <ProcessMiningPanel
                  path="/data-analysis"
                  pageTitle={{title: "data analysis", sidebar: true}}
                  sidebarItems={['filters']}
                  component={DataAnalysis}
              />
              <ProcessMiningPanel
                  path="/share/data_analysis/:id"
                  pageTitle={{title: "data analysis", sidebar: true}}
                  sidebarItems={['filters']}
                  component={DataAnalysis}
              />
              <Route
                  path="/dashboard"
                  render={({match: {url}}) => (
                      <div className="dashboard d-flex flex-column">
                        <Header/>
                        <main className="mt-4 pb-5 d-flex flex-grow-1">
                          <SideBar/>
                          <Route path={`${url}/`} component={WorkSpace} exact/>
                          {/*<Route path={`${url}/home`} component={Home} exact/>*/}
                          <Route path={`${url}/data-pool`} component={DataPool}/>
                          <Route path={`${url}/admin-panel`} component={UserManagement}/>
                          <Route path={`${url}/workspace`} component={WorkSpace}/>
                          <Route path={`${url}/overview-dashboard`} component={OverviewDashboard}/>
                        </main>
                      </div>
                  )}
              />
            </Switch>
          </Router>
          <OfflineErrorBox isOnline={onlineStatus}/>
        </QueryClientProvider>
      </AppContext.Provider>
  );
}catch (er){
    return 'test'
}

}

export default App;